import { startWith } from 'rxjs/operators';
import { LocalSearchService } from './../../../core/services/local-search.service';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { AngebotsListenHttpService } from 'src/app/core/services/angebots-listen-http.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-angebotsversionslisten-edit',
  templateUrl: './angebotsversionslisten-edit.component.html',
  styleUrls: ['./angebotsversionslisten-edit.component.scss']
})
export class AngebotsversionslistenEditComponent implements OnInit {

  public loading = false;
  public avl;
  public editMode = false;
  public search = new FormControl();

  constructor(private angebotsService: AngebotsListenHttpService, private activatedRoute: ActivatedRoute, private snack: MatSnackBar) { }

  ngOnInit(): void {
    this.loading = true;
    this.activatedRoute.params.subscribe(params => {
      let avlId = params.id;
      this.angebotsService.getAngebotsVersionsListe(avlId).subscribe(res => {
        this.avl = res;
        this.avl.preiseFiltered = this.avl.rabatte;
        this.avl.id = avlId;
        this.loading = false;
      }, err => {console.log(err); this.loading = false;});
    });

    this.search.valueChanges.subscribe(val => {
      this.avl.preiseFiltered = LocalSearchService.search(this.avl.rabatte, val);
    })
  }

  public saving = false;
  save() {
    this.saving = true;
    this.angebotsService.putAngebotsVersionsListeBase(this.avl.id, this.avl).subscribe(res => {
      this.saving = false;
      this.snack.open("Erfolgreich gespeichert", 'Erfolgreich', {panelClass: 'success-snackbar'});
    }, err => {
      console.log(err);
      this.saving = false;
    })
  }

  savePos(element) {
    element.saving = true;
    this.angebotsService.putAngebotsVersionsListePos(element).subscribe(res => {
      this.snack.open('Angebotslisten-Position wurde erfolgreich gespeichert', '', {panelClass: 'success-snackbar'});
      element.saving = false;
      element.edit = false;
    }, err => {
      element.saving = false;
      console.log(err);
    })
  }
}
